import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '../../utils/baseQuery'

export interface AdminSettings {
  _id: string
  jobTitle: string
  projectName: string
  interviewDate: string
  interviewTime: string
  hrManagerName: string
  adminName: string
  profilePic?: {
    name: string
    url: string
  }
}

interface SettingsResponse {
  success: boolean
  message: string
  data: AdminSettings | null
}

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery,
  tagTypes: ['Settings'],
  endpoints: (builder) => ({
    getSettings: builder.query<SettingsResponse, void>({
      query: () => '/settings',
      providesTags: ['Settings'],
    }),
    saveSettings: builder.mutation<SettingsResponse, FormData>({
      query: (body) => ({
        url: '/settings',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Settings'],
    }),
  }),
})

export const { useGetSettingsQuery, useSaveSettingsMutation } = settingsApi
